export enum UserRoleEnum {
    superAdmin = "ROLE_SUPER_ADMIN",
    admin = "ROLE_ADMIN"
}